import { getFieldSpellConfig } from '@shared/index'
import type { MatchState } from '@shared/index'

export type FieldAmbienceKey =
  | 'forest'
  | 'wasteland'
  | 'mountain'
  | 'sogen'
  | 'umi'
  | 'yami'
  | 'generic'

export type FieldAmbience = {
  key: FieldAmbienceKey
  name: string
  cardId: string
}

const KEY_BY_ID: Record<string, FieldAmbienceKey> = {
  '87430998': 'forest',
  '23424603': 'wasteland',
  '50913601': 'mountain',
  '86318356': 'sogen',
  '22702055': 'umi',
  '59197169': 'yami',
}

/**
 * Face-up Field Spell on the board (LOB: one terrain for both players).
 */
export function activeFieldAmbience(
  state: MatchState | null,
): FieldAmbience | null {
  if (!state) return null
  for (const seat of [0, 1] as const) {
    const fs = state.zones[seat].fieldSpell
    if (!fs?.faceUp || !fs.cardId) continue
    const cfg = getFieldSpellConfig(Number(fs.cardId))
    if (!cfg) continue
    return {
      key: KEY_BY_ID[fs.cardId] ?? 'generic',
      name: cfg.name,
      cardId: fs.cardId,
    }
  }
  return null
}
